<template>
  <b-row>
    <b-col md="12">
      <h5>Connected To QuickBooks</h5>
    </b-col>
    <b-col md="12">
      <div v-if="company.oauth_data">
        <h5>Connected</h5>
        <div class="d-flex align-items-center h-100">
          <b-button variant="outline-primary" @click="handleConnect">Reconnect</b-button>
        </div>
      </div>
      <div v-else class="d-flex align-items-center h-100">
        <b-button variant="outline-primary" @click="handleConnect">Connect</b-button>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BMedia,
  BAvatar,
  BLink,
  BButton,
} from 'bootstrap-vue';
import {ValidationProvider} from "vee-validate";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BMedia,
    BAvatar,
    BLink,
    BButton,

    ValidationProvider
  },
  props: {
    company: Object
  },
  created() {
    window.addEventListener('message', this.handleMessage);

    // if (!this.company.oauth_data) {
    //   this.handleConnect()
    // }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleConnect() {
      let w = 500;
      let h = 500;

      let left = (window.screen.width / 2) - (w / 2);
      let top = (window.screen.height / 2) - (h / 2);

      let link = `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${w},height=${h},top=${top},left=${left}`;

      window.open(`/qb_oauth/${this.company.id}`, '_blank', link);

      window.addEventListener('message', this.handleMessage);

    },
    handleMessage(event) {
      console.log(event);

      const full = location.protocol + '//' + location.host;
      const originUrl = event.origin;

      console.log(full, originUrl, event.data)

      if (full.indexOf(originUrl) !== -1) {
        const data = event.data;

        if (data.oauthToken) {
          const token = data.oauthToken.token;
          const companyId = data.oauthToken.companyId;

          this.$set(this.company, 'oauth_data', token)
          this.$set(this.company, 'company_id', companyId)
        }
      }
    }
  }
}
</script>
